import Area, { AreaInitializer } from './Area';
import Line, { LineInitializer } from './Line';

export interface StationInitializer {
  id: number;
  originalStationId: number;
  name: string;
  lineId: number;
  line: LineInitializer;
  prefectureAreaId: number;
  prefectureArea: AreaInitializer;
  areaId: number | null;
  area: AreaInitializer | null;
}

export default class Station {
  public readonly id: number;
  public readonly originalStationId: number;
  public readonly name: string;
  public readonly lineId: number;
  public readonly line: Line;
  public readonly prefectureAreaId: number;
  public readonly prefectureArea: Area;
  public readonly areaId: number | null;
  public readonly area: Area | null;

  constructor(init: StationInitializer) {
    this.id = init.id;
    this.originalStationId = init.originalStationId;
    this.name = init.name;
    this.lineId = init.lineId;
    this.line = new Line(init.line);
    this.prefectureAreaId = init.prefectureAreaId;
    this.prefectureArea = new Area(init.prefectureArea);
    this.areaId = init.areaId;
    this.area = init.area ? new Area(init.area) : null;
  }

  public nameWithSuffix(): string {
    return this.name + '駅';
  }
}
